exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.onboard-title[data-v-79d2a423] {\n  padding-top: 20px;\n}\n.form-wrapper[data-v-79d2a423] {\n  padding: 40px 0 80px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n.nav-wrapper[data-v-79d2a423] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: 64px;\n  height: auto;\n}\n[type=\"checkbox\"] + label[data-v-79d2a423] {\n  color: black;\n  height: auto;\n}\n[type=\"checkbox\"].filled-in + label[data-v-79d2a423]:after, [type=\"checkbox\"].filled-in + label[data-v-79d2a423]:before {\n  top: 15px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-79d2a423","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Onboard.vue
// module id = 427
// module chunks = 1